<script>
    export let img, projectTierData

    $: imageUrl = img.data ? img.data.attributes.url : img.url;
</script>

<div class="left relative">
    <figure>
    <img src={imageUrl} alt="#">
    </figure>
</div>